import { copyToClipboard } from './copyToClipboard';

type CopyableQueryProps = {
  sql: string;
  copyLabel: string;
};

function CopyableQuery({ sql, copyLabel }: CopyableQueryProps): JSX.Element {
  return (
    <>
      <pre className="diagnostics-affected-url-query">{sql}</pre>
      <button
        type="button"
        className="diagnostics-detail-chip"
        onClick={() => void copyToClipboard(sql)}
        aria-label={copyLabel}
      >
        <span className="diagnostics-detail-chip-name">Copy query</span>
      </button>
    </>
  );
}

export default CopyableQuery;
